import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, Radio, RadioGroup, TextField } from '@material-ui/core';
import Close from '@material-ui/icons/Close';
import { activeAutom, activeTab, alertState, defaultItems } from '../../../../../../recoil-store/recoil-state';
import { useRecoilState, useSetRecoilState } from 'recoil';
import { createErrorHistory } from '../../../../../../helpers/flowHistory';
// Import CSS
import "./DetailTabs.css"
import { Autocomplete } from '@material-ui/lab';

/**
 * @Description This function returns Delete Variant dialog.
 * @Returns     Component
 * @Author      ibrahim AKIN
 */

const groupColors = ["rgba(34, 30, 51, 1)", "rgba(89, 72, 118, 1)", "rgba(110, 170, 174, 1)", "rgba(174, 222, 211, 1)",
    "rgba(251, 228, 89, 1)", "rgba(253, 188, 53, 1)", "rgba(252, 134, 47, 1)", "rgba(222, 76, 35, 1)", "rgba(21, 12, 64, 1)", "rgba(77, 24, 177, 1)", "rgba(73, 117, 225, 1)",
    "rgba(99, 225, 221, 1)", "rgba(144, 255, 219, 1)", "rgba(203, 146, 82, 1)"
]

function TabDialog({ open, setOpen, detailTabs, setDetailTabs, setErrorHandlingAutomDetails }) {
    const { t } = useTranslation();
    const label = 'CONTENT.FLOW.';
    const setAutomDetail = useSetRecoilState(activeAutom);
    const [tabFilter, setTabFilter] = useRecoilState(activeTab);
    const setAlert = useSetRecoilState(alertState);
    const handleClose = () => { setOpen(null); };
    const handleClick = () => {
        function isTabExists(e, item) {
            if (e) {
                for (const iterator of e) {
                    if (iterator.item?.id === item?.id) {
                        return false;
                    }
                }
            }
            return true;
        }
        if (!values.name || !values.color) {
            return setAlert(alert => ({
                ...alert,
                show: true,
                message: t("MESSAGES.AUTOMS.FILL-THE-REQUIRED-FIELDS"),
                severity: "error"
            }))
        }
        else if (open.from === "header" && !values.action?.id) {
            return setAlert(alert => ({
                ...alert,
                show: true,
                message: t("MESSAGES.AUTOMS.FILL-THE-REQUIRED-FIELDS"),
                severity: "error"
            }))
        }
        if (open.from !== "ehFlow" && detailTabs && !isTabExists(detailTabs, open.from === "header" ? values.action : open.item)) {
            if (open.from !== "header") {
                setOpen(null);
            }
            return setAlert(alert => ({
                ...alert,
                show: true,
                message: t("MESSAGES.AUTOMS.ACTION-ALREADY-HAS-A-TAB"),
                severity: "error"
            }))
        }
        if (open.from === "ehFlow") {
            let di = JSON.parse(JSON.stringify(defaultItems))
            let copyAutom
            setAutomDetail((autom) => {
                copyAutom = JSON.parse(JSON.stringify(autom))
                return autom
            })
            open.item.eh_flow = { ...copyAutom, items: JSON.parse(JSON.stringify(defaultItems)), id: open.item.id, tabName: values.name, tabColor: values.color }
            // setErrorHandlingAutomDetail({ ...copyAutom, items: defaultItems, errorHandlingId: action.id })
            // setErrorHandlingAutomDetail({ items: defaultItems, errorHandlingId: action.id })
            setErrorHandlingAutomDetails((pre) => [...pre, { ...copyAutom, items: JSON.parse(JSON.stringify(defaultItems)), errorHandlingId: open.item.id, tabName: values.name, tabColor: values.color }])
            setTabFilter(open.item.id)
            // setTabFilter(detailTabs.length + 1)
            setDetailTabs(e => [...e, { ...values, item: [], errorHandling: true, id: open.item.id }]);
            createErrorHistory(open.item.id, di)
        }
        else if (open.from === "header") {
            setDetailTabs(e => [...e, { ...values, item: values.action, id: "custom_" + values.action.id }]);
        }
        else {
            setDetailTabs(e => [...e, { ...values, item: open.item, id: "custom_" + open.item.id }]);
        }
        setOpen(null);
    }

    const [values, setValues] = useState({ name: open.from === "header" ? "" : open.from === "group" ? open.item.name : open.item.actionName, color: '', action: {} })

    // const handleChange = (prop) => (event) => setValues({ ...values, [prop]: event.target.value });
    const handleChange = (prop, value) => setValues({ ...values, [prop]: value });

    const controlProps = (item) => ({
        checked: values.color === item,
        style: { color: item },
        color: 'default',
        value: item
    });
    return (
        <Dialog className='add-tabs-dialog' onClose={handleClose} open
            PaperProps={{
                style: {
                    width: 320.34,
                },
            }}
        >
            <DialogTitle>
                {/* <div className="dialog-header variant">
                    {t(label + 'OPEN-TAB')}
                    <Button onClick={handleClose}>
                        <Close fontSize="small" />
                    </Button>
                </div> */}
                <div id="about-title" className="add-group-header">
                    <h4 className="autom-group-title">{t(label + "ADD-GROUP")}</h4>
                    <Button data-test="cancelgroup-button" onClick={handleClose}>
                        <Close className="dialog-close-icon" />
                    </Button>
                </div>
            </DialogTitle>
            <DialogContent>

                {open.from === "header" ?
                    <div className="form-element">
                        <div className="modal-text add-tab-name">
                            <div>{t(label + "SELECT-ACTION")}<span className="mandatory-field">*</span> </div>
                        </div>
                        <small
                            className="conf-field-desc"><em>{t(label + 'SELECT-ACTION-DESCRIPTION')}</em></small>
                        <Autocomplete
                            onChange={(e, newValue) => {
                                handleChange("action", newValue)
                            }}
                            value={values.action}
                            size="small"
                            // classes={{
                            //     option: classes.option,
                            // }}
                            options={open.groupableActions}
                            getOptionLabel={(option) => {
                                return option.label ? option.label : option.actionName
                            }}
                            renderInput={params =>
                                <TextField {...params} placeholder="No Group Selected" variant="outlined" inputProps={{
                                    ...params.inputProps,
                                    "aria-autocomplete": 'new-password',
                                    autoComplete: 'new-password', // disable autocomplete and autofill
                                    style: {
                                        marginLeft: '3px',
                                        fontSize: 12,
                                        fontWeight: 600,
                                        color: '#46474E'
                                    }
                                }} />}

                        />
                    </div>
                    : ""}
                {/* <div className="dialog-body"> */}
                {/* <div style={{ textAlign: 'left' }}>
                        {t(label + 'NAME')}:
                        <FormControlLabel style={{ width: 237 }} labelPlacement="start" control={
                            <TextField fullWidth onChange={handleChange('name')}
                                value={values.name} size="small" variant="outlined" />
                        } />
                    </div> */}
                <div className="form-element">
                    <div className="modal-text add-tab-name">
                        <div>{t(label + "TAB-NAME")}<span className="mandatory-field">*</span> </div>
                    </div>
                    <small
                        className="conf-field-desc"><em>{t(label + 'TAB-NAME-DESCRIPTION')}</em></small>
                    <TextField fullWidth onChange={(e) => handleChange('name', e.target.value)}
                        value={values.name} size="small" variant="outlined" />
                </div>
                <div className="form-element add-group-color-container">
                    <div className="modal-text add-group-name">
                        <div>{t(label + "TAB-COLOR")}<span className="mandatory-field">*</span> </div>
                    </div>
                    <small
                        className="conf-field-desc"><em>{t(label + 'TAB-COLOR-DESCRIPTION', { type: 'string' })}</em></small>
                    <div className="colors-container">
                        {groupColors.map((color, index) => {
                            return <div id={`color${index}`} className="color-div" style={{
                                backgroundColor: color,
                                border: `${values?.color ? color === values.color ? "2px solid green" : "none" : "none"}`
                            }}
                                onClick={(e) => handleChange("color", color)}></div>
                        })}
                    </div>
                </div>
                {/* </div> */}
            </DialogContent>
            <DialogActions
                style={{
                    justifyContent: "center",
                    padding: "16px 24px 24px 24px",
                }}
            >
                <Button className='dialog-add-button' onClick={handleClick}>{t(label + 'ADD-TAB')}</Button>

            </DialogActions>
        </Dialog >
    )
}
export default TabDialog;